class LicenseRestAdapter {
  constructor (restAdapter) {
    if (restAdapter && restAdapter.extend) {
      restAdapter.extend(this, 'license')
    }
  }
}

module.exports = LicenseRestAdapter
